const tooltipText = `As of October 1, 2024, total eligible ZEV sales converted to total eligible<br /> 
    ZEVs supplied to align with amendments to the ZEV Act. Note that MY<br />
    2023 ZEVs and earlier is based on suppliers' sales information.`;

export { tooltipText };
